import { motion } from 'framer-motion';

// Line-by-line masked reveal. Each line lives inside overflow-hidden
// and animates a translate from 100% -> 0% with a stagger delay.
export const KineticLines = ({
	lines,
	className = '',
	delay = 0.1,
	stagger = 0.09,
	as: Tag = 'h1',
}) => {
	return (
		<Tag className={className}>
			{lines.map((line, i) => (
				<span key={i} className="reveal-line">
					<motion.span
						initial={{ y: '110%' }}
						animate={{ y: '0%' }}
						transition={{
							duration: 0.9,
							ease: [0.22, 1, 0.36, 1],
							delay: delay + i * stagger,
						}}
					>
						{line}
					</motion.span>
				</span>
			))}
		</Tag>
	);
};

export default KineticLines;
